export default __webpack_public_path__ + "static/media/1937.bf93f669.png";